import React from 'react';
import { Box, Text } from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import moment from 'moment';

export const ApplicaitonSummaryNotification = ({
  notification,
  toggleRead,
}) => {
  const history = useHistory();
  const { params } = useRouteMatch();
  const message = JSON.parse(notification.message);

  return (
    <Box
      pad="15px 40px 5px 40px"
      background={notification.read ? '' : '#d8d8e36b'}
      style={{ borderRight: '3px solid #D8D8E3', cursor: 'pointer' }}
      onClick={() =>
        history.push(
          `/${params.orgName}/applicants/?applicationId=${message.applicationId}`
        )
      }
    >
      <Text>
        <b>{message?.candidateIds?.length} Candidates</b> have applied to &nbsp;
        <b>{message?.applicationName || message?.applicationTitle}</b>
      </Text>
      <Box
        margin="15px 0 10px"
        display="flex"
        style={{ justifyContent: 'space-between' }}
      >
        <Text size="11px" color="#9D9DB7" bold>
          {moment(notification.createdAt).calendar()}
        </Text>

        <Text size="11px" color={Theme.PrimaryColor} onClick={toggleRead}>
          <span style={{ cursor: 'pointer' }}>
            Mark as {notification.read ? 'Unread' : 'Read'}
          </span>
        </Text>
      </Box>
    </Box>
  );
};

ApplicaitonSummaryNotification.propTypes = {
  notification: PropTypes.object,
  toggleRead: PropTypes.func,
};

export const BackgroundTaskNotification = ({ notification, toggleRead }) => {
  const message = JSON.parse(notification.message);

  function processEmail(status) {
    if (status === 'STARTED') {
      return 'Email(s) is/are currently being sent out to the receiver(s)';
    } else if (status === 'FAILED') {
      return message?.reason || 'Email(s) failed to send';
    } else {
      return 'Email(s) sent out successfully!!!';
    }
  }

  function processExport(status) {
    if (status === 'STARTED') {
      return 'Candidate(s) export is currently being processed.';
    } else if (status === 'FAILED') {
      return message?.reason || 'Candidate export failed';
    } else {
      return 'Candidate(s) exported successfully!!!';
    }
  }

  const taskTypes = {
    EMAIL_CANDIDATE: processEmail(message?.status),
    EXPORT_CANDIATE: processExport(message?.status),
  };

  return (
    <Box
      pad="15px 40px 5px 40px"
      background={notification.read ? '' : '#d8d8e36b'}
      style={{ borderRight: '3px solid #D8D8E3', cursor: 'pointer' }}
      onClick={() => toggleRead()}
    >
      <Text>{taskTypes[message.type]}</Text>
      <Box
        margin="15px 0 10px"
        display="flex"
        style={{ justifyContent: 'space-between' }}
      >
        <Text size="11px" color="#9D9DB7" bold>
          {moment(notification.createdAt).calendar()}
        </Text>

        <Text size="11px" color={Theme.PrimaryColor} onClick={toggleRead}>
          <span style={{ cursor: 'pointer' }}>
            Mark as {notification.read ? 'Unread' : 'Read'}
          </span>
        </Text>
      </Box>
    </Box>
  );
};

BackgroundTaskNotification.propTypes = {
  notification: PropTypes.object,
  toggleRead: PropTypes.func,
};

export const QueryTaskNotification = ({ notification, toggleRead }) => {
  const message = JSON.parse(notification.message);

  function getTotalQueries() {
    return message?.PENDING || 0 + message?.SUCCESS || 0 + message?.FAILED || 0;
  }

  return (
    <Box
      pad="15px 40px 5px 40px"
      background={notification.read ? '' : '#d8d8e36b'}
      style={{ borderRight: '3px solid #D8D8E3', cursor: 'pointer' }}
      onClick={() => toggleRead()}
    >
      <Text>
        Out of {getTotalQueries()} queried transactions you have {message?.PENDING || 0}{' '}
        Pending, {message?.SUCCESS || 0} Successful and {message?.FAILED || 0}{' '}
        Failed queried transactions.
      </Text>
      <Box
        margin="15px 0 10px"
        display="flex"
        style={{ justifyContent: 'space-between' }}
      >
        <Text size="11px" color="#9D9DB7" bold>
          {moment(notification.createdAt).calendar()}
        </Text>

        <Text size="11px" color={Theme.PrimaryColor} onClick={toggleRead}>
          <span style={{ cursor: 'pointer' }}>
            Mark as {notification.read ? 'Unread' : 'Read'}
          </span>
        </Text>
      </Box>
    </Box>
  );
};

QueryTaskNotification.propTypes = {
  notification: PropTypes.object,
  toggleRead: PropTypes.func,
};
